import { GridColDef } from '@mui/x-data-grid';
import { getLocaleDate } from 'utils';

export const COLUMNS: GridColDef[] = [
  {
    field: 'createdAt',
    headerName: 'Created At',
    flex: 1,
    valueFormatter: ({ value }) => getLocaleDate(value),
    sortable: false,
    filterable: false,
  },
  {
    field: 'updatedAt',
    headerName: 'Updated At',
    flex: 1,
    valueFormatter: ({ value }) => (value ? getLocaleDate(value) : null),
    sortable: false,
    filterable: false,
  },
  {
    field: 'type',
    headerName: 'Type',
    flex: 1,
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
    sortable: false,
    filterable: false,
  },
  {
    field: 'email',
    headerName: 'Email',
    flex: 1,
  },
  {
    field: 'reason',
    headerName: 'Comment',
    sortable: false,
    filterable: false,
    flex: 1,
  },
];
